import React from "react";
import styled from "styled-components";
import { Button, Popover } from "@mui/material";
import { NotificationType } from "../Utilities/FormDesignConstants";
import { ExclamationIcon } from "../../CommonUI/Icon/ExclamationIcon";
import { ExclamationRedIcon } from "../../CommonUI/Icon/ExclamationRedIcon";
import { WarningIcon } from "../../CommonUI/Icon/WarningIcon";
import { WarningRedIcon } from "../../CommonUI/Icon/WarningRedIcon";
import { ValidationIssue } from "../../rule-engine-core/Common/IDesignValidationProvider";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants"; // eslint-disable-next-line

// eslint-disable-next-line
const InfoButton = styled(({ type, ...otherProps }) => <Button {...otherProps} />)`
    &.MuiButtonBase-root {
        background: ${(props) =>
            props.type === NotificationType.ERROR ? UIStyleConstants.RED_COLOR : UIStyleConstants.ORANGE_COLOR};
        color: ${UIStyleConstants.WHITE_COLOR};
        border-radius: 20px;
        font-size: 15px;
        line-height: 18px;
        font-weight: 700;
        padding: 10px 15px;

        img {
            margin-right: 12px;
        }

        &:hover {
            background: ${(props) =>
                props.type === NotificationType.ERROR
                    ? UIStyleConstants.RED_VERY_LIGHT_COLOR
                    : UIStyleConstants.ORANGE_LIGHT_COLOR};
        }
    }
`;

const NotificationList = styled.div`
    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    padding: 0 10px 10px;
`;

const NotificationItem = styled.div`
    background: ${UIStyleConstants.GRAY_LIGHT_COLOR};
    padding: 7px 6px;
    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    font-size: 12px;
    line-height: 15px;

    margin-top: 10px;
    display: flex;
    align-items: center;
    border-radius: 5px;

    img {
        margin-right: 9px;
        width: 12px;
    }
`;

interface NotificationRenderingProps {
    type?: NotificationType | undefined;
    messages: ValidationIssue[];
    show?: boolean;
}

interface NotificationRenderingState {
    open: boolean;
}

export class NotificationRendering extends React.Component<NotificationRenderingProps, NotificationRenderingState> {
    infobuttonRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

    constructor(props: NotificationRenderingProps) {
        super(props);
        this.state = {
            open: false,
        };
    }

    onClosePopover = () => {
        this.setState({
            open: false,
        });
    };

    onOpenPopover = () => {
        if (this.props.messages.length > 0) {
            this.setState({
                open: true,
            });
        }
    };

    render() {
        const type = this.props.type || NotificationType.ERROR;

        let buttonIcon: JSX.Element | null = null;
        let itemIcon: JSX.Element | null = null;

        if (type === NotificationType.ERROR) {
            buttonIcon = <ExclamationIcon alt="Error" />;
            itemIcon = <ExclamationRedIcon alt="Error" />;
        } else if (type === NotificationType.WARNING) {
            buttonIcon = <WarningIcon alt="Warning" />;
            itemIcon = <WarningRedIcon alt="Warning" />;
        }

        return (
            <div
                ref={this.infobuttonRef}
                data-testid={type === NotificationType.ERROR ? "error-notification" : "warn-notification"}
            >
                <InfoButton
                    type={type}
                    onClick={this.onOpenPopover}
                    data-testid={`btn-design-${type}-validation`}
                >
                    {buttonIcon} {this.props.messages.length}
                </InfoButton>
                <Popover
                    open={this.state.open}
                    anchorEl={this.infobuttonRef.current}
                    onClose={this.onClosePopover}
                >
                    <NotificationList>
                        {this.props.messages.map((m, idx) => {
                            const message = `${m.elementId} ${m.dataName || ""} ${m.issue}`;
                            return (
                                <NotificationItem key={idx}>
                                    {itemIcon} <span>{message}</span>
                                </NotificationItem>
                            );
                        })}
                    </NotificationList>
                </Popover>
            </div>
        );
    }
}
